import { BaseViewStore } from 'core/stores';
import { makeObservable } from 'mobx';
import FulfillmentOrderStore from './FulfillmentOrderStore';
import { LookupStore } from 'modules/lookup/stores';
import _ from 'lodash';

class ResultReportViewStore extends BaseViewStore {
	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.lookupStore = new LookupStore(rootStore);
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.data = modalParams.data;
		this.fulfillmentOrderAction = modalParams.fulfillmentOrderAction;
	}
}

export default ResultReportViewStore;
